function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#24aae9;}.cls-1{opacity:0.2;}.cls-2{fill:#05517f;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M133.38,69.39c-3.69-3.88-10.21-10-17.5-17.43-14.15-14.46-14.3-14.3-21.38-21.54-.21-.2-8.76-8.52-8.92-8.76-.75-1.12-4.24-4.91-9-4.41-4.79-.5-8.28,3.29-9,4.41-.17.24-8.72,8.56-8.93,8.76C51.54,37.66,51.38,37.5,37.23,52c-7.29,7.45-13.81,13.55-17.5,17.43-1.38,1.45-1.73,4.11,2.69,3.8H33.84a2.48,2.48,0,0,1,2.47,2.47v41.42a7.6,7.6,0,0,0,7.6,7.6H109.2a7.61,7.61,0,0,0,7.61-7.6V75.66a2.47,2.47,0,0,1,2.46-2.47h11.42C135.11,73.5,134.76,70.84,133.38,69.39Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M187.41,125.48h5.83a5.24,5.24,0,1,1,0,10.48h-2.83v6.42h-3Zm5.73,7.93a2.35,2.35,0,0,0,2.35-2.65c0-1.58-.88-2.68-2.35-2.68h-2.73v5.33Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M203.54,134a4.82,4.82,0,0,1,5.1-4.93,7.24,7.24,0,0,1,2.12.33l-.55,2.42a7,7,0,0,0-1.55-.22,2.18,2.18,0,0,0-2.22,2.4v8.37h-2.9Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M214.84,134.76c0-3.68,2.27-5.68,5.37-5.68s5.4,2,5.4,5.7V137c0,3.67-2.27,5.69-5.4,5.69s-5.37-2-5.37-5.69Zm5.37,5.42c1.65,0,2.5-1.08,2.5-3.3v-2c0-2.23-.85-3.3-2.5-3.3s-2.47,1.07-2.47,3.3v2C217.74,139.1,218.59,140.18,220.21,140.18Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M231.16,134.31c0-3.5,2.23-5.23,4.9-5.23a3.79,3.79,0,0,1,3.43,2,3.79,3.79,0,0,1,3.44-2c2.7,0,4.9,1.73,4.9,5.23v8.07h-2.92v-7.82c0-1.95-.7-2.95-2-2.95s-2,1.17-2,3.37v7.4H238V135c0-2.2-.73-3.37-2-3.37s-2,1-2,2.95v7.82h-2.93Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M253.39,134.76c0-3.68,2.27-5.68,5.37-5.68s5.4,2,5.4,5.7V137c0,3.67-2.28,5.69-5.4,5.69s-5.37-2-5.37-5.69Zm5.37,5.42c1.65,0,2.5-1.08,2.5-3.3v-2c0-2.23-.85-3.3-2.5-3.3s-2.47,1.07-2.47,3.3v2C256.29,139.1,257.14,140.18,258.76,140.18Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M269.71,129.41h2.9v7.82c0,2,.9,3,2.25,3s2.22-1,2.22-3v-7.82H280v8a5.15,5.15,0,1,1-10.3,0Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M284.64,129.41h3l1.92,6.3c.28.94.6,2.32.85,3.57.3-1.28.6-2.63.87-3.57l1.93-6.3h3l-4.13,13h-3.32Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M300.21,134.76c0-3.68,2.28-5.68,5.37-5.68s5.4,2,5.4,5.7V137c0,3.67-2.27,5.69-5.4,5.69s-5.37-2-5.37-5.69Zm5.37,5.42c1.65,0,2.5-1.08,2.5-3.3v-2c0-2.23-.85-3.3-2.5-3.3s-2.47,1.07-2.47,3.3v2C303.11,139.1,304,140.18,305.58,140.18Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M316.36,125.76a1.75,1.75,0,0,1,3.5,0,1.75,1.75,0,0,1-3.5,0Zm.3,3.65h2.92v13h-2.92Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M325.59,134a4.82,4.82,0,0,1,5.09-4.93,7.31,7.31,0,0,1,2.13.33l-.55,2.42a7.05,7.05,0,0,0-1.55-.22,2.19,2.19,0,0,0-2.23,2.4v8.37h-2.89Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M345.61,124.26l2.92-.5v18.62h-2.92Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M358.81,134.38h2.05v-.47c0-1.48-.73-2.3-2.05-2.3a12.28,12.28,0,0,0-3.5.62l-.63-2.37a13.6,13.6,0,0,1,4.13-.78c3,0,5,1.88,5,4.83v4.47c0,2.47-2.28,4.32-4.95,4.32s-4.95-1.87-4.95-4.32C353.91,135.73,355.91,134.38,358.81,134.38Zm.05,5.8a1.88,1.88,0,0,0,2-1.8v-1.85h-2.08a1.68,1.68,0,0,0-1.9,1.8A1.84,1.84,0,0,0,358.86,140.18Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M377.28,134.53c0-3.7,2.43-5.45,5.05-5.45a5.16,5.16,0,0,1,2.55.75v-5.75h2.95v13.2a5.28,5.28,0,1,1-10.55,0Zm5.28,5.65c1.32,0,2.32-1,2.32-3v-4.87a5,5,0,0,0-2.3-.67c-1.32,0-2.4.8-2.4,3v2.49C380.18,139.2,381.23,140.18,382.56,140.18Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M393.18,125.76a1.75,1.75,0,0,1,3.5,0,1.75,1.75,0,0,1-3.5,0Zm.3,3.65h2.93v13h-2.93Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M406.68,134.38h2.05v-.47c0-1.48-.72-2.3-2.05-2.3a12.28,12.28,0,0,0-3.5.62l-.62-2.37a13.48,13.48,0,0,1,4.12-.78c3,0,5,1.88,5,4.83v4.47c0,2.47-2.27,4.32-4.95,4.32s-5-1.87-5-4.32C401.78,135.73,403.78,134.38,406.68,134.38Zm.05,5.8a1.88,1.88,0,0,0,2-1.8v-1.85h-2.07a1.68,1.68,0,0,0-1.9,1.8A1.83,1.83,0,0,0,406.73,140.18Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M417.33,124.26l2.93-.5v18.62h-2.93Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M425.21,129.41h2.92l1.15,8.12c.23,1.5.75,2.32,1.93,2.32h.92l1.3-10.44h2.93L434,147.65h-2.88l.7-5.27h-.67c-2.95,0-4.33-1.88-4.73-4.6Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M441.06,139.58a11.12,11.12,0,0,0,3.37.6c1.13,0,1.93-.58,1.93-1.35,0-2.4-5.55-1.5-5.55-6,0-2.18,1.75-3.78,4.57-3.78a10.4,10.4,0,0,1,3.45.6l-.65,2.45a9,9,0,0,0-2.8-.52c-1.15,0-1.57.55-1.57,1.25,0,2.25,5.52,1.3,5.52,5.92,0,2-1.57,3.92-4.9,3.92a11.62,11.62,0,0,1-3.95-.72Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M454.16,134.46c0-3.5,2.3-5.38,5.12-5.38a4.91,4.91,0,0,1,5.15,4.9v2.75h-7.37v.47c0,2,1,3,2.65,3a12,12,0,0,0,3.52-.6l.58,2.4a10.87,10.87,0,0,1-4.1.72c-3.3,0-5.55-1.9-5.55-5.5Zm7.35.12V134a2.21,2.21,0,0,0-2.23-2.37,2.25,2.25,0,0,0-2.22,2.55v.42Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M482.41,134.38h2v-.47c0-1.48-.73-2.3-2-2.3a12.28,12.28,0,0,0-3.5.62l-.63-2.37a13.6,13.6,0,0,1,4.13-.78c3,0,5,1.88,5,4.83v4.47c0,2.47-2.28,4.32-5,4.32s-4.95-1.87-4.95-4.32C477.51,135.73,479.51,134.38,482.41,134.38Zm-3.05-8.45.85-2.1,5.25,2.28-.78,1.8Zm3.1,14.25a1.88,1.88,0,0,0,2-1.8v-1.85h-2.08a1.68,1.68,0,0,0-1.9,1.8A1.84,1.84,0,0,0,482.46,140.18Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M500.88,134.53c0-3.7,2.43-5.45,5.05-5.45a5.16,5.16,0,0,1,2.55.75v-5.75h2.95v13.2a5.28,5.28,0,1,1-10.55,0Zm5.28,5.65c1.32,0,2.32-1,2.32-3v-4.87a5,5,0,0,0-2.3-.67c-1.32,0-2.4.8-2.4,3v2.49C503.78,139.2,504.83,140.18,506.16,140.18Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M516.63,134.76c0-3.68,2.28-5.68,5.38-5.68s5.4,2,5.4,5.7V137c0,3.67-2.28,5.69-5.4,5.69s-5.38-2-5.38-5.69Zm5.38,5.42c1.65,0,2.5-1.08,2.5-3.3v-2c0-2.23-.85-3.3-2.5-3.3s-2.48,1.07-2.48,3.3v2C519.53,139.1,520.38,140.18,522,140.18Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M533,134.31c0-3.5,2.22-5.23,4.9-5.23a3.79,3.79,0,0,1,3.42,2,3.81,3.81,0,0,1,3.45-2c2.7,0,4.9,1.73,4.9,5.23v8.07H546.7v-7.82c0-1.95-.69-2.95-2-2.95s-2,1.17-2,3.37v7.4h-2.93V135c0-2.2-.72-3.37-2-3.37s-2,1-2,2.95v7.82H533Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M555.33,125.76a1.75,1.75,0,0,1,3.5,0,1.75,1.75,0,0,1-3.5,0Zm.3,3.65h2.93v13h-2.93Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M564.23,134.76c0-4,2.33-5.68,5.57-5.68a13.09,13.09,0,0,1,3.73.6l-.6,2.43a10.83,10.83,0,0,0-3-.5c-1.77,0-2.77.87-2.77,3.2V137c0,2.35,1,3.23,2.77,3.23a11.42,11.42,0,0,0,3-.5l.62,2.42a12.84,12.84,0,0,1-3.75.6c-3.24,0-5.57-1.7-5.57-5.67Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M578.76,125.76a1.75,1.75,0,0,1,3.5,0,1.75,1.75,0,0,1-3.5,0Zm.3,3.65H582v13h-2.92Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M588.11,124.26l2.92-.5v18.62h-2.92Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M596.71,134.46c0-3.5,2.3-5.38,5.12-5.38A4.91,4.91,0,0,1,607,134v2.75H599.6v.47c0,2,1,3,2.65,3a12,12,0,0,0,3.53-.6l.57,2.4a10.87,10.87,0,0,1-4.1.72c-3.3,0-5.54-1.9-5.54-5.5Zm7.34.12V134a2.2,2.2,0,0,0-2.22-2.37,2.26,2.26,0,0,0-2.23,2.55v.42Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M187,43.4h22c12.25,0,20.07,9.23,20.07,19.88S221.21,82.87,209,82.87H198.31v24.21H187Zm21.57,29.86c5.56,0,8.86-4.05,8.86-10s-3.3-10.08-8.86-10.08H198.31V73.26Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M238.26,75.53c0-11.21,8.38-18.56,19.21-18.56a27.53,27.53,0,0,1,8,1.22l-2.07,9.14a26.18,26.18,0,0,0-5.84-.85c-5.09,0-8.39,3.68-8.39,9v31.55H238.26Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M271.32,78.35c0-13.85,8.57-21.38,20.26-21.38s20.34,7.53,20.34,21.48v8.38c0,13.85-8.57,21.48-20.34,21.48s-20.26-7.63-20.26-21.48Zm20.26,20.44c6.21,0,9.42-4.05,9.42-12.43V78.92c0-8.39-3.21-12.44-9.42-12.44s-9.33,4-9.33,12.44v7.44C282.25,94.74,285.45,98.79,291.58,98.79Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M322.1,77.5c0-13.94,9.13-20.53,19-20.53a19.31,19.31,0,0,1,9.61,2.82V38.13h11.12V87.87c0,13-9.23,20.44-19.88,20.44s-19.87-7.44-19.87-20.44ZM342,98.79c5,0,8.76-3.67,8.76-11.39V69a18.66,18.66,0,0,0-8.66-2.55c-5,0-9,3-9,11.5V87.4C333,95.12,337,98.79,342,98.79Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M372.5,44.44a6.6,6.6,0,0,1,13.18,0,6.59,6.59,0,0,1-13.18,0Zm1.13,13.75h11v48.89h-11Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M413.85,76.94h7.73V75.15c0-5.56-2.74-8.67-7.73-8.67a46.3,46.3,0,0,0-13.19,2.36l-2.35-9A51.62,51.62,0,0,1,413.85,57c11.3,0,18.84,7.06,18.84,18.18V92c0,9.33-8.57,16.3-18.65,16.3-10.55,0-18.65-7.07-18.65-16.3C395.39,82,402.92,76.94,413.85,76.94ZM414,98.79c4.71,0,7.54-3.39,7.54-6.78V85h-7.82c-5.28,0-7.16,3.2-7.16,6.78S409.05,98.79,414,98.79Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M442.77,77.5c0-13.94,9.14-20.53,19-20.53a19.34,19.34,0,0,1,9.61,2.82V38.13h11.12V87.87c0,13-9.24,20.44-19.88,20.44s-19.88-7.44-19.88-20.44Zm19.88,21.29c5,0,8.76-3.67,8.76-11.39V69a18.73,18.73,0,0,0-8.67-2.55c-5,0-9,3-9,11.5V87.4C453.7,95.12,457.66,98.79,462.65,98.79Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M492.61,78.35c0-13.85,8.57-21.38,20.25-21.38s20.35,7.53,20.35,21.48v8.38c0,13.85-8.58,21.48-20.35,21.48s-20.25-7.63-20.25-21.48Zm20.25,20.44c6.22,0,9.42-4.05,9.42-12.43V78.92c0-8.39-3.2-12.44-9.42-12.44s-9.33,4-9.33,12.44v7.44C503.53,94.74,506.74,98.79,512.86,98.79Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M544.61,76.66C544.61,63.47,553,57,563.07,57A14.27,14.27,0,0,1,576,64.69,14.32,14.32,0,0,1,589,57c10.17,0,18.46,6.5,18.46,19.69v30.42h-11V77.6c0-7.35-2.64-11.12-7.44-11.12s-7.45,4.43-7.45,12.72v27.88h-11V79.2c0-8.29-2.73-12.72-7.44-12.72s-7.44,3.77-7.44,11.12v29.48h-11Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M101.75,148.73c-12.1,0-19.77-6.42-28.44-17.19l-.27-.38-5.64-9.33,6-3.63,5.52,9.14c9.65,11.94,15.75,15.27,26,14.22a19,19,0,0,0,14-7.71,29.92,29.92,0,0,0,5.63-17.68V79.08h16.11c4,0,5-1.71,5.26-4.28A9.1,9.1,0,0,0,143,67.28C131.47,56.44,93.14,20.33,83.72,10.9,81,8.16,78.32,6.87,75.83,7c-3.65.24-6.21,3.5-6.24,3.54L64,6.33C64.18,6.09,68.43.52,75.28,0,79.91-.3,84.41,1.7,88.67,6c9.35,9.36,47.61,45.41,59.11,56.24a16,16,0,0,1,5.08,13.4c-.76,6.67-5.21,10.49-12.21,10.49h-9.11v30.09a37,37,0,0,1-7,21.84,26.08,26.08,0,0,1-18.91,10.51A37.46,37.46,0,0,1,101.75,148.73Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M28.42,122.68h-7V86.08H12.3c-7,0-11.44-3.82-12.2-10.49a16.07,16.07,0,0,1,5.07-13.4C16.69,51.34,55,15.25,64.29,6,68.54,1.7,73-.3,77.67,0,84.52.52,88.77,6.09,89,6.33l-5.6,4.19,2.8-2.1-2.79,2.13S80.77,7.25,77.13,7c-2.5-.16-5.15,1.15-7.89,3.89C59.87,20.27,21.51,56.42,10,67.28A9,9,0,0,0,7.05,74.8c.3,2.57,1.3,4.28,5.25,4.28H28.42Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M59.53,124.37A17.8,17.8,0,0,1,50.38,120a37.94,37.94,0,0,1-12.81-30.9,42.63,42.63,0,0,1,1.94-10.49,34.87,34.87,0,0,1,1.94-5A17.93,17.93,0,0,1,73.79,89.13a7.31,7.31,0,0,0-.43,2.28,3.67,3.67,0,0,0,0,.52A14.7,14.7,0,0,0,76,95l.26.28a17.92,17.92,0,0,1-12.94,29.25A18.3,18.3,0,0,1,59.53,124.37Zm-.31-53.58a10.73,10.73,0,0,0-5.2.45,10.84,10.84,0,0,0-6.3,5.51,28.83,28.83,0,0,0-1.54,4,35.94,35.94,0,0,0-1.62,8.78,30.89,30.89,0,0,0,10.5,25.3,10.84,10.84,0,0,0,7.88,2.79,10.89,10.89,0,0,0,7.55-3.6,10.91,10.91,0,0,0,.45-14.1c-3.14-3.11-4-5.05-4.25-5.94a9.41,9.41,0,0,1-.32-2.48,13.75,13.75,0,0,1,1-5.07l.06-.14a10.94,10.94,0,0,0-8.19-15.45ZM73.42,92s0,.07,0,.1v0A1.32,1.32,0,0,0,73.42,92Zm-.06-.15Z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M95,104.62a17.92,17.92,0,0,1-14.48-22.5l.13-.36a14.92,14.92,0,0,0,1.11-3.82l-.05-.15.05.15v-.06a3.33,3.33,0,0,0-.18-.49,6.93,6.93,0,0,0-1.3-1.92,17.93,17.93,0,0,1,23.36-27.2A35.52,35.52,0,0,1,107.42,52a42.8,42.8,0,0,1,6,8.82,38,38,0,0,1,.72,33.44A17.93,17.93,0,0,1,99.07,104.8,17.32,17.32,0,0,1,95,104.62ZM87.22,84.16a10.94,10.94,0,0,0,6.09,12.72,10.84,10.84,0,0,0,8.36.25,10.84,10.84,0,0,0,6.09-5.73A30.94,30.94,0,0,0,107.18,64a35.49,35.49,0,0,0-5-7.38,28.23,28.23,0,0,0-3-3A10.93,10.93,0,0,0,85,70.26l.12.1A14,14,0,0,1,88,74.6a9.73,9.73,0,0,1,.7,2.42C88.86,77.94,88.83,80.06,87.22,84.16ZM81.79,78v0s0-.06,0-.1S81.79,78,81.79,78Zm0-.24Z"
});

function SvgProdiadom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 607.44 148.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdiadom);
export default __webpack_public_path__ + "static/media/prodiadom.26397ccf.svg";
export { ForwardRef as ReactComponent };